import { Static, Object, String, Optional } from '@sinclair/typebox';

export type RebookingFlightOffersRequestQuery = Static<typeof RebookingFlightOffersRequestQuery>;
export const RebookingFlightOffersRequestQuery = Object({
  pnr: String(),
  lastName: String(),
  outboundDate: Optional(
    String({
      examples: ['2024-08-20'],
      description: 'Date of departure',
      pattern: '^20(2[4-9]|[3-9][0-9])-[0-9]{2}-[0-9]{2}$',
    })
  ),
  inboundDate: Optional(
    String({
      examples: ['2024-08-30'],
      description: 'Date of return trip (required for round-trip)',
      pattern: '^20(2[4-9]|[3-9][0-9])-[0-9]{2}-[0-9]{2}$',
    })
  ),
  selectedCouponCodes: Optional(String()),
});
